function escapeRegExp(value) {
    return value.replace(/[-[\]/{}()*+?.\\^$|]/g, '\\$&');
}

export function normalizeSearchText(value = '') {
    return `${value}`
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/\s+/g, ' ')
        .trim();
}

export function scoreSearchTextMatch(text, query) {
    const normalizedText = normalizeSearchText(text);
    const normalizedQuery = normalizeSearchText(query);

    if (!normalizedText || !normalizedQuery) {
        return 0;
    }

    let score = 0;

    if (normalizedText === normalizedQuery) {
        score += 10000;
    }

    if (normalizedText.startsWith(normalizedQuery)) {
        score += 7000;
    }

    const wordStartPattern = new RegExp(`(^|[\\s\\-_/()])${escapeRegExp(normalizedQuery)}`);

    if (wordStartPattern.test(normalizedText)) {
        score += 5000;
    }

    if (normalizedText.includes(normalizedQuery)) {
        score += 3000;
    }

    const queryTokens = normalizedQuery.split(' ').filter(Boolean);

    queryTokens.forEach(token => {
        const tokenWordStartPattern = new RegExp(`(^|[\\s\\-_/()])${escapeRegExp(token)}`);

        if (tokenWordStartPattern.test(normalizedText)) {
            score += 250;
        } else if (normalizedText.includes(token)) {
            score += 75;
        }
    });

    return score;
}
